import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon_check_default",
  "use": "icon-icon_check_default-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-icon_check_default\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 0h16v16H0z\" /><path d=\"M8 1.833c1.703 0 3.245.69 4.36 1.806A6.147 6.147 0 0 1 14.168 8c0 1.703-.69 3.245-1.806 4.36A6.147 6.147 0 0 1 8 14.168a6.147 6.147 0 0 1-4.36-1.806A6.147 6.147 0 0 1 1.832 8c0-1.703.69-3.245 1.806-4.36A6.147 6.147 0 0 1 8 1.832Z\" stroke=\"#BEBFCA\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol